import type { FaireProductEntity } from "../../entity_types/product";

export const potluck_kimchi_base_1: FaireProductEntity = {
  token: "potluck-kimchi-base-1",
  type: "product",
  name: "Kimchi Base Seasoning",
  brandName: "Potluck",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1f5fc70299bc5e6af6328c56ce5a6715af841aaa37d9002be999bf81d53d7624.webp",
  priceDollars: 9,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/6edcc1e721d6c6e418cb5378f3f92caca5f10171ea43c6c3da92e2bc6f9da5b1.webp",
  weight: 0.5,
  dimensions: {
    width: 2,
    height: 4,
    depth: 2,
  },
  description:
    "All-in-one seasoning for homemade kimchi. Makes fermentation easy.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["korean", "seasoning", "kimchi", "fermented"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
